import React, { useContext, useState } from "react";
import Cookies from "js-cookie";
interface AuthContextT {
	token?: any;
	user?: any;
	loginUser?: any;
	logoutUser?: any;
}
const AuthContext = React.createContext<AuthContextT>({});

const AuthProvider = ({ children }: any) => {
	const [user, setUser] = useState(JSON.parse(sessionStorage.getItem("_faraday-session")!));

	const loginUser = async (): Promise<string> => {
		return new Promise(async (resolve, reject) => {
			try {
				
				const params = new URLSearchParams(window.location.search);
				let userData = params.get("_faraday");

				if (userData && userData != "null") {
					userData = JSON.parse(decodeURIComponent(atob(userData)));
					setUser(userData);
					sessionStorage.setItem("_faraday-session", JSON.stringify(userData));
					resolve("success");
					return;
				}
				if (!userData) resolve("ok");
				if (userData == "null") resolve("fail");
			} catch (error) {
				console.log(error);
				resolve("fail");
			}
		});
	};

	const logoutUser = async () => {
		try {
			const response = await fetch(`${process.env.REACT_APP_HOST_DOMAIN}/api/auth/logout`, {
				method: "GET",
				credentials: "include",
			});
			const res = await response.json();
			if (!res.isAuth) {
				sessionStorage.removeItem("_faraday-session");
				setUser(null);
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<AuthContext.Provider value={{ user, loginUser, logoutUser }}>{children}</AuthContext.Provider>
	);
};

export default AuthProvider;

export const useAuth = () => {
	return useContext(AuthContext);
};
